import React from 'react';

import css from './Title.module.scss';

export type TitleProps = {
    text: string;
    hideDivider?: boolean;
};

const Title = ({ text, hideDivider }: TitleProps) => {
    return (
        <div>
            <div className={css.tfa_title}>{text}</div>
            {!hideDivider && <div className={css.tfa_title__divider} />}
        </div>
    );
};

export default Title;
